(() => {
  const openingScreen = document.querySelector('[data-opening-screen]');
  if (!openingScreen) return;

  const viewport = openingScreen.querySelector('[data-opening-screen-viewport]');
  const enterButton = openingScreen.querySelector('[data-opening-screen-enter]');
  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let startScrollLeft = 0;
  let startScrollTop = 0;

  document.documentElement.classList.add('opening-screen-active');
  document.body.classList.add('opening-screen-active');
  window.scrollTo({ top: 0, left: 0 });

  const centerImage = () => {
    if (!viewport || !openingScreen.classList.contains('opening-screen--pan')) return;

    viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
    viewport.scrollTop = (viewport.scrollHeight - viewport.clientHeight) / 2;
  };

  const closeOpeningScreen = () => {
    openingScreen.classList.add('is-hidden');
    document.documentElement.classList.remove('opening-screen-active');
    document.body.classList.remove('opening-screen-active');
    window.scrollTo({ top: 0, left: 0 });
  };

  if (enterButton) {
    enterButton.addEventListener('click', closeOpeningScreen);
  }

  if (viewport) {
    viewport.addEventListener('pointerdown', (event) => {
      if (event.button !== undefined && event.button !== 0) return;

      isDragging = true;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = viewport.scrollLeft;
      startScrollTop = viewport.scrollTop;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!isDragging) return;

      event.preventDefault();
      viewport.scrollLeft = startScrollLeft - (event.clientX - startX);
      viewport.scrollTop = startScrollTop - (event.clientY - startY);
    });

    const stopDragging = () => {
      isDragging = false;
      viewport.classList.remove('is-dragging');
    };

    viewport.addEventListener('pointerup', stopDragging);
    viewport.addEventListener('pointercancel', stopDragging);
    viewport.addEventListener('lostpointercapture', stopDragging);
  }

  window.requestAnimationFrame(centerImage);
})();
